import styled from 'styled-components';

export const OrchestratorLayout = styled.div`
  display: flex;
  gap: 1rem;
  height: 100%;

  > .general-info {
    flex: 3;
  }
  > .step {
    flex: 6;
  }
  > .in-progress {
    flex: 3;
    overflow-y: scroll;
    height: 100%;
  }

  &:not(:has(.in-progress)) > .general-info {
    flex: 4;
  }
  &:not(:has(.in-progress)) > .step {
    flex: 8;
  }
`;
